import styled from 'styled-components';
import vars from '../lib/styled';

export default styled.section`
    margin: ${props => (props.marginless ? '0 auto' : '2rem auto 0')};
    padding: 0 6rem;
    width: ${vars.container};

    @media (max-width: ${vars.breakpoint.laptop}) {
        padding: 1rem 3rem;
    }

    @media (max-width: ${vars.breakpoint.tablet}) {
        padding: 0.5rem;
    }
`;
